<template>
  <div class="fcom_tiptap_wrapper">
    <!-- Toolbar -->
    <div class="fcom_tiptap_toolbar">
      <!-- Inline marks -->
      <button type="button" :class="{ 'is-active': editor?.isActive('bold') }" :title="__('bold')" @click="editor?.chain().focus().toggleBold().run()"><b>B</b></button>
      <button type="button" :class="{ 'is-active': editor?.isActive('italic') }" :title="__('italic')" @click="editor?.chain().focus().toggleItalic().run()"><i>I</i></button>
      <button type="button" :class="{ 'is-active': editor?.isActive('underline') }" :title="__('underline')" @click="editor?.chain().focus().toggleUnderline().run()"><u>U</u></button>
      <button type="button" :class="{ 'is-active': editor?.isActive('strike') }" :title="__('strikethrough')" @click="editor?.chain().focus().toggleStrike().run()"><s>S</s></button>
      <button type="button" :class="{ 'is-active': editor?.isActive('code') }" :title="__('code')" @click="editor?.chain().focus().toggleCode().run()"> &lt;/&gt; </button>

      <span class="fcom_tiptap_sep" />

      <!-- Headings -->
      <button type="button" :class="{ 'is-active': editor?.isActive('heading', { level: 2 }) }" :title="__('heading_2')" @click="editor?.chain().focus().toggleHeading({ level: 2 }).run()"> H2 </button>
      <button type="button" :class="{ 'is-active': editor?.isActive('heading', { level: 3 }) }" :title="__('heading_3')" @click="editor?.chain().focus().toggleHeading({ level: 3 }).run()"> H3 </button>

      <span class="fcom_tiptap_sep" />

      <!-- Lists -->
      <button type="button" :class="{ 'is-active': editor?.isActive('bulletList') }" :title="__('bullet_list')" @click="editor?.chain().focus().toggleBulletList().run()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
      </button>
      <button type="button" :class="{ 'is-active': editor?.isActive('orderedList') }" :title="__('numbered_list')" @click="editor?.chain().focus().toggleOrderedList().run()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="10" y1="6" x2="21" y2="6"/><line x1="10" y1="12" x2="21" y2="12"/><line x1="10" y1="18" x2="21" y2="18"/><path d="M4 6h1v4"/><path d="M4 10h2"/><path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"/></svg>
      </button>

      <span class="fcom_tiptap_sep" />

      <!-- Blocks -->
      <button type="button" :class="{ 'is-active': editor?.isActive('blockquote') }" :title="__('blockquote')" @click="editor?.chain().focus().toggleBlockquote().run()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V21c0 1 0 1 1 1z"/>
          <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V21c0 1 0 1 1 1z"/>
        </svg>
      </button>
      <button type="button" :class="{ 'is-active': editor?.isActive('codeBlock') }" :title="__('code_block')" @click="editor?.chain().focus().toggleCodeBlock().run()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
      </button>
      <button type="button" :title="__('horizontal_rule')" @click="editor?.chain().focus().setHorizontalRule().run()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>
      </button>

      <span class="fcom_tiptap_sep" />

      <!-- Link -->
      <button type="button" :class="{ 'is-active': editor?.isActive('link') }" :title="__('link')" @click="insertLink">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
        </svg>
      </button>

      <span class="fcom_tiptap_sep" />

      <!-- Media -->
      <button type="button" :title="__('insert_image')" @click="insertImage">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
          <circle cx="8.5" cy="8.5" r="1.5"/>
          <polyline points="21 15 16 10 5 21"/>
        </svg>
      </button>
      <button type="button" :title="__('insert_video')" @click="insertVideo">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/>
          <line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/>
          <line x1="2" y1="12" x2="22" y2="12"/>
          <line x1="2" y1="7" x2="7" y2="7"/><line x1="2" y1="17" x2="7" y2="17"/>
          <line x1="17" y1="17" x2="22" y2="17"/><line x1="17" y1="7" x2="22" y2="7"/>
        </svg>
      </button>

      <span class="fcom_tiptap_sep" />

      <!-- History -->
      <button type="button" :disabled="!editor?.can().undo()" :title="__('undo')" @click="editor?.chain().focus().undo().run()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7v6h6"/><path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"/></svg>
      </button>
      <button type="button" :disabled="!editor?.can().redo()" :title="__('redo')" @click="editor?.chain().focus().redo().run()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 7v6h-6"/><path d="M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3L21 13"/></svg>
      </button>

      <span class="fcom_tiptap_sep" />

      <!-- Clear formatting -->
      <button type="button" :title="__('clear_formatting')" @click="editor?.chain().focus().unsetAllMarks().clearNodes().run()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 7v6h6"/><path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"/>
        </svg>
      </button>
    </div>

    <!-- Editor content -->
    <EditorContent :editor="editor" class="fcom_tiptap_content" />
  </div>
</template>

<script setup>
import { watch, onBeforeUnmount } from 'vue'
import { useEditor, EditorContent } from '@tiptap/vue-3'
import StarterKit      from '@tiptap/starter-kit'
import Underline       from '@tiptap/extension-underline'
import Link            from '@tiptap/extension-link'
import Placeholder     from '@tiptap/extension-placeholder'
import Image           from '@tiptap/extension-image'
import Youtube         from '@tiptap/extension-youtube'
import { __ } from '@/utils/i18n.js'

const props = defineProps({
  modelValue:  { type: String, default: '' },
  placeholder: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])

const editor = useEditor({
  content: props.modelValue,
  extensions: [
    StarterKit,
    Underline,
    Link.configure({
      openOnClick: false,
      HTMLAttributes: { rel: 'noopener noreferrer nofollow', target: '_blank' },
    }),
    Placeholder.configure({ placeholder: props.placeholder }),
    Image.configure({ inline: false, allowBase64: true, HTMLAttributes: { class: 'fcom_editor_image' } }),
    Youtube.configure({ inline: false, width: 640, height: 360, HTMLAttributes: { class: 'fcom_editor_video' } }),
  ],
  onUpdate: ({ editor }) => {
    emit('update:modelValue', editor.getHTML())
  },
})

watch(() => props.modelValue, (val) => {
  if (editor.value && editor.value.getHTML() !== val) {
    editor.value.commands.setContent(val, false)
  }
})

onBeforeUnmount(() => editor.value?.destroy())

function insertLink() {
  const current = editor.value?.getAttributes('link').href
  const url = window.prompt(__('enter_url'), current)
  if (url === null) return
  if (url === '') {
    editor.value?.chain().focus().extendMarkRange('link').unsetLink().run()
  } else {
    editor.value?.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
  }
}

function insertImage() {
  const url = window.prompt(__('enter_image_url'))
  if (url) editor.value?.chain().focus().setImage({ src: url }).run()
}

function insertVideo() {
  const url = window.prompt(__('enter_video_url'))
  if (url) editor.value?.commands.setYoutubeVideo({ src: url, width: 640, height: 360 })
}
</script>
